const headers = {
  name: "Session View",
  navigate: {
    path: [
      {
        name: "Session",
        path: "/app/billing/session",
      },
      {
        name: "View",
        path: "",
      },
    ],
  },
};

export default headers;
